import { render } from "./TableLite.vue?vue&type=template&id=6ec24a82&scoped=true"
import script from "./TableLite.vue?vue&type=script&lang=js"
export * from "./TableLite.vue?vue&type=script&lang=js"

import "./TableLite.vue?vue&type=style&index=0&id=6ec24a82&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec24a82"]])

export default __exports__